import { render, staticRenderFns } from "./DashboardRelink.vue?vue&type=template&id=d477971a&scoped=true&"
import script from "./DashboardRelink.vue?vue&type=script&lang=js&"
export * from "./DashboardRelink.vue?vue&type=script&lang=js&"
import style0 from "./DashboardRelink.vue?vue&type=style&index=0&id=d477971a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d477971a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DashboardSingleInfoCard: require('/workspace/components/Dashboard/DashboardSingleInfoCard.vue').default,DashboardBarCard: require('/workspace/components/Dashboard/DashboardBarCard.vue').default,DashboardPieCard: require('/workspace/components/Dashboard/DashboardPieCard.vue').default,DashboardTopWithTotal: require('/workspace/components/Dashboard/DashboardTopWithTotal.vue').default})
